/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

import { i18nStrings as it } from './locales/it';

const i18nStrings = {
	it: it
}

export const LanguageTypes = [
	{
		"code": "it",
		"lang": "Italiano"
	}
];

export default i18nStrings;
